module.exports = __webpack_public_path__ + "static/majapa-fcf37ead6bd1400acdac56e3b7b89a96.png";